/**
 * Team-size bands, derived from profile_data.agentCount.
 *
 * Calibrated to how brokerage and team headcount actually reads in the industry:
 * a 24-agent office is a small office, not a "Mega" one, and "Enterprise" starts
 * where an org genuinely operates at scale (200+). Getting this wrong is
 * immediately obvious to any agent looking at an Explore card.
 *
 * A missing or non-positive agentCount has no band — never coerce it into one.
 */

export interface TeamSizeBand {
  id: string;
  label: string;
  description: string;
  min: number;
  max: number;
}

export const TEAM_SIZE_BANDS: TeamSizeBand[] = [
  { id: "boutique",   label: "Boutique",   description: "1–9",     min: 1,   max: 9 },
  { id: "small",      label: "Small",      description: "10–24",   min: 10,  max: 24 },
  { id: "mid_size",   label: "Mid-size",   description: "25–74",   min: 25,  max: 74 },
  { id: "large",      label: "Large",      description: "75–199",  min: 75,  max: 199 },
  { id: "enterprise", label: "Enterprise", description: "200+",    min: 200, max: Infinity },
];

/** Returns the band for a given agent count, or null when the count is missing, non-positive, or below 1. */
export const resolveTeamSizeBand = (agentCount: number | null | undefined): TeamSizeBand | null => {
  if (agentCount == null || !Number.isFinite(agentCount) || agentCount < 1) return null;
  return TEAM_SIZE_BANDS.find((b) => agentCount >= b.min && agentCount <= b.max) ?? null;
};
